import logo from '../assets/images/website-logo.png';

const DEVICON_BASE = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons';

export const site = {
  name: 'Shah Kabir',
  role: 'Software Developer',
  availability: 'Open to new opportunities',
  focusAreas: ['full-stack applications', 'AI-powered tools', 'automation & APIs'],
  tagline:
    'I build software that solves real problems — from web apps and APIs to automation, with a focus on clean code and thoughtful user experience.',
  heroSubtitle:
    'Full-stack applications, AI-powered tools, and automation — built with clean code and thoughtful UX.',
  logo,
  nav: [
    { id: 'projects', label: 'Projects' },
    { id: 'about', label: 'About' },
    { id: 'contact', label: 'Contact' },
  ],
  social: [
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/shah-kabir', icon: 'linkedin' },
    { label: 'GitHub', href: 'https://github.com/shahkabir1', icon: 'github' },
    { label: 'X', href: 'https://x.com/ShahKabir109', icon: 'x' },
  ],
  techStack: [
    { name: 'React', iconUrl: `${DEVICON_BASE}/react/react-original.svg` },
    { name: 'Next.js', iconUrl: `${DEVICON_BASE}/nextjs/nextjs-original.svg` },
    { name: 'Node.js', iconUrl: `${DEVICON_BASE}/nodejs/nodejs-original.svg` },
    { name: 'Python', iconUrl: `${DEVICON_BASE}/python/python-original.svg` },
    { name: 'PostgreSQL', iconUrl: `${DEVICON_BASE}/postgresql/postgresql-original.svg` },
    { name: 'TypeScript', iconUrl: `${DEVICON_BASE}/typescript/typescript-original.svg` },
    { name: 'MongoDB', iconUrl: `${DEVICON_BASE}/mongodb/mongodb-original.svg` },
    { name: 'Docker', iconUrl: `${DEVICON_BASE}/docker/docker-original.svg` },
    { name: 'FastAPI', iconUrl: `${DEVICON_BASE}/fastapi/fastapi-original.svg` },
    { name: 'Tailwind CSS', iconUrl: `${DEVICON_BASE}/tailwindcss/tailwindcss-original.svg` },
    { name: 'Vite', iconUrl: `${DEVICON_BASE}/vitejs/vitejs-original.svg` },
    { name: 'Prisma', iconUrl: `${DEVICON_BASE}/prisma/prisma-original.svg` },
    { name: 'Google Cloud', iconUrl: `${DEVICON_BASE}/googlecloud/googlecloud-original.svg` },
  ],
  projectsIntro:
    'Selected work across full-stack development, AI, and automation. Click a project for the full write-up.',
  contactIntro:
    'Interested in working together or have a question? Send a message below or connect on social media.',
};
